'use strict';
const VerticalSubtreeCollection = require('./vertical-subtree-collection');
module.exports = function combineVerticalSubtrees(node, childLayouts, margin, sameLevel) {
	const result = {
			nodes: { }
		},
		shift = function (nodes, xOffset) {
			Object.values(nodes).forEach((n) => n.x += xOffset);
			return nodes;
		},
		verticalSubtreeCollection = new VerticalSubtreeCollection(childLayouts, margin),
		bubbleWith = (node.bubble && node.bubble.width) || node.width,
		bubbleX = (node.bubble && node.bubble.x) || 0;
	let treeOffset;

	if (Array.isArray(childLayouts)) {
		throw 'child layouts are an array!';
	}

	result.nodes[node.id] = node;
	node.x = Math.round(-0.5 * bubbleWith) - bubbleX;
	result.levels = [{width: node.width, xOffset: node.x}];

	if (!verticalSubtreeCollection.isEmpty()) {
		if (sameLevel) {
			result.levels = verticalSubtreeCollection.getMergedLevels();
			treeOffset = result.levels[0].xOffset;
		} else {
			result.levels = result.levels.concat(verticalSubtreeCollection.getMergedLevels());
			treeOffset = result.levels[1].xOffset;
		}
		Object.keys(childLayouts).forEach((subtreeRank) => {
			Object.assign(result.nodes, shift(childLayouts[subtreeRank].nodes, treeOffset + verticalSubtreeCollection.getExpectedTranslation(subtreeRank)));
		});
	}
	return result;
};
